<template>
  <div class="projectManagerMain">
    <div>
      <el-form :model="searchForm" ref="searchForm" label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="Name:" prop="empCode">
              <el-select
                v-model="searchForm.empCode"
                clearable
                filterable
                remote
                placeholder="Please input"
                :remote-method="value => remoteMethod('searchUserList', value)"
              >
                <el-option v-for="(item, index) in searchUserList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16" style="text-align: right; padding: 7px 0 20px 0;">
            <el-button type="primary" size="mini" @click="getProjectManagerList">Search</el-button>
            <el-button type="primary" size="mini" @click="openEditManager">Add</el-button>
            <el-button type="primary" size="mini" @click="openImport">Import</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="contentTableDiv">
        <el-table :data="tableData" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}" >
          <el-table-column prop="id" v-if="false"></el-table-column>
          <el-table-column prop="empName" label="Emp Name" align="center" min-width="100"></el-table-column>
          <el-table-column prop="empCode" label="Emp Code" align="center" min-width="100"></el-table-column>
          <el-table-column prop="certificateType" label="Certificate Type" align="center" min-width="130"></el-table-column>
          <el-table-column prop="effectiveStartTime" label="Effective Start Date" align="center" min-width="130">
            <template slot-scope="scope">
              {{ scope.row.effectiveStartTime ? moment(scope.row.effectiveStartTime).format('YYYY-MM-DD') : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="effectiveEndTime" label="Effective End Date" align="center" min-width="130">
            <template slot-scope="scope">
              {{ scope.row.effectiveEndTime ? moment(scope.row.effectiveEndTime).format('YYYY-MM-DD') : '' }}
            </template></el-table-column>
          <el-table-column prop="firstDept" label="Primary Department" align="center" min-width="180"></el-table-column>
          <el-table-column prop="secondDept" label="Secondary Department" align="center" min-width="180"></el-table-column>
          <el-table-column prop="thirdDept" label="Tertiary Department" align="center" min-width="180"></el-table-column>
          <el-table-column label="Operation" align="center" fixed="right" width="270">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="openEditManager(scope.row)">Edit</el-button>
              <el-button size="mini" type="danger" @click="deleteManager(scope.row)">Delete</el-button>
              <el-button size="mini" type="success" @click="openUpload(scope.row)">Upload</el-button>
            </template>
          </el-table-column>
      </el-table> 
      </div>
      <div class="pageDiv">
        <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10,20,50,100]" :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <!--修改--> 
    <el-dialog :visible.sync="editManagerModal" :destroy-on-close="true" class="managerDialog" :close-on-click-modal="false" width="600px" :title="editManagerForm && editManagerForm.id ? 'Edit Project Manager' : 'Add Project Manager'">
      <div slot="footer">
        <el-button size="small" @click="closeModal">Cancel</el-button>
        <el-button type="primary" size="small" @click="confirmConfig" :loading="confirmLoading">Confirm</el-button>
      </div>
      <el-form :model="editManagerForm" ref="editManagerForm" label-width="170px" class="projectManager">
        <el-form-item label="Name:" prop="empCode" :rules="{ required: true, message: 'Please input' }">
          <el-select
            v-model="editManagerForm.empCode"
            clearable
            filterable
            remote
            placeholder="Please input"
            :remote-method="value => remoteMethod('editUserList', value)"
            @change="changeUser"
          >
            <el-option v-for="(item, index) in editUserList.slice(0, 10)" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Certificate Type:" prop="certificateType" :rules="{ required: true, message: 'Please input' }">
          <el-input v-model="editManagerForm.certificateType" clearable size="small" placeholder="Please input" />
        </el-form-item>
        <el-form-item label="Effective Date:" prop="effectiveTime" :rules="{ required: true, message: 'Please input' }">
          <el-date-picker
            v-model="editManagerForm.effectiveTime"
            type="daterange"
            range-separator="-"
            start-placeholder="Start date"
            end-placeholder="End date"
            placeholder="Please select"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Primary Department:" prop="firstDept" :rules="{ required: true, message: 'Please input' }">
          <el-input v-model="editManagerForm.firstDept" clearable size="small" placeholder="Please input" />
        </el-form-item>
        <el-form-item label="Secondary Department:" prop="secondDept" :rules="{ required: true, message: 'Please input' }">
          <el-input v-model="editManagerForm.secondDept" clearable size="small" placeholder="Please input" />
        </el-form-item>
        <el-form-item label="Tertiary Department:" prop="thirdDept" :rules="{ required: true, message: 'Please input' }">
          <el-input v-model="editManagerForm.thirdDept" clearable size="small" placeholder="Please input" />
        </el-form-item>
      </el-form>
    </el-dialog>
		<el-dialog
			title="Upload"
			width="500px"
			:visible.sync="uploadModal"
			:close-on-click-modal="false"
      class="managerDialog"
		>
			<el-form :model="uploadForm" ref="uploadForm" label-width="125px">
				<el-form-item label="Certificate:" prop="file" :rules="[{ required: true, message: 'Please upload' }]">
					<el-upload
						class="upload-demo"
						:action="this.$store.state.islhurl + '/s3/upload'"
						:before-upload="beforeUpload"
						:limit="1"
						:file-list="fileList"
						:on-change="changeFile"
						:on-remove="handleRemove"
						:on-exceed="handleExceed"
						:on-preview="handlePreview"
						:auto-upload="false"
						v-model="uploadForm.file"
					>
						<el-button size="small" type="primary">Upload</el-button>
					</el-upload>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeUpload()">Cancel</el-button>
				<el-button type="primary" :loading="uploadLoading" size="small" @click="uploadConfirm()">Confirm</el-button>
			</span>
		</el-dialog>
		<el-dialog
			title="Import"
			width="500px"
			:visible.sync="importModal"
			:close-on-click-modal="false"
      class="managerDialog"
		>
			<el-form :model="importForm" ref="importForm" label-width="125px">
				<el-form-item label="Import" prop="file" :rules="[{ required: true, message: 'Please upload' }]">
					<el-upload
						class="upload-demo"
						:action="this.$store.state.islhurl + '/s3/upload'"
						:before-upload="beforeUpload"
						:limit="1"
						:file-list="importFileList"
						:on-change="changeImportFile"
						:on-remove="handleImportRemove"
						:on-exceed="handleExceed"
						:on-preview="handlePreview"
						:auto-upload="false"
						v-model="importForm.file"
					>
						<el-button size="small" type="primary">Upload</el-button>
					</el-upload>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeImport()">Cancel</el-button>
				<el-button type="primary" :loading="importLoading" size="small" @click="importConfirm()">Confirm</el-button>
			</span>
		</el-dialog>
  </div>
</template>
<style>
  
</style>
<script>
  import moment from 'moment';
  export default {
    name: 'projectManagerMain',
    created () {
      this.getProjectManagerList();
    },
    data () {
      return {
        moment,
        searchForm: {},
        editManagerModal: false,
        editManagerForm: {},
        currentPage: 1,
        totalCount: 0,
        pageSize: 10,
        tableData: [],
        confirmLoading: false,
        detailModal: false,
        detailInfo: {},
        searchUserList: [],
        editUserList: [],
        userAllList: [],
        uploadModal: false,
        uploadForm: {},
        fileList: [],
        uploadLoading: false,
        importModal: false,
        importForm: {},
        importFileList: [],
        importLoading: false,
      }
    },
    methods: {
			remoteMethod(list, query, row) {
				if (query !== '') {
					// 清除之前的定时器
					if (this.timeout) {
						clearTimeout(this.timeout)
					}
					// 防抖处理，300ms后执行
					this.timeout = setTimeout(() => {
						this.fetchUserOptions(list, query)
            if(row && row.id) {
              this.editManagerForm = {
                ...row,
                effectiveTime: [row.effectiveStartTime, row.effectiveEndTime],
              };
            }
					}, 200)
				} else {
					this[list] = [];
				}
			},
			fetchUserOptions(list, query) {
				let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
				this._get(url).then().then(res => {
					if(res.code === 200 && res.data) {
						this[list] = res.data;
					} else {
						this[list] = [];
					}
				}).catch(error => {
					this[list] = [];
					console.error('搜索失败:', error)
				})
			},
      getProjectManagerList() {
        let url = `${this.$store.state.islhurl}majorProjectManager/getListByPage/${this.pageSize}/${this.currentPage}`
        let pm = {
          ...this.searchForm, 
          islhToken: sessionStorage.getItem('islhtoken')
        }
        this._post(url,pm).then(
          res =>{
            if(res.code == 200) {
              this.tableData =res.data
              this.totalCount = res.totalNums
            }
          }
        )
      },
      changeUser(values) {
        let userInfo = this.editUserList.find(item => {
          return item.empCode === values;
        });
        this.editManagerForm.empName = userInfo.empName;
      },
      openEditManager(row) {
        this.editManagerModal = true;
        if(row && row.id) {
          this.remoteMethod('editUserList', row.empCode, row);
          // this.editManagerForm = {
          //   ...row,
          //   effectiveTime: [row.effectiveStartTime, row.effectiveEndTime],
          // };
        } else {
          this.editManagerForm = {};
          this.editUserList = [];
        }
      },
      deleteManager(row) {
        this.$confirm("Are you sure to delete", "Warning", {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          let url = `${this.$store.state.islhurl}majorProjectManager/delete`
          let params = {
            id: row.id,
            islhToken: sessionStorage.getItem('islhtoken'),
          }
          this._post(url, params).then(
            res =>{
              if(res.code === 200) {
                this.getProjectManagerList();
                this.$Message.success('Delete Successful' )
              } else {
                this.$message({
                  type:'error',
                  message: res
                });
              }
            }
          )
        }).catch(() => {
        });
      },
      closeModal() {
        this.editManagerModal = false;
        this.editManagerForm = {};
      },
      confirmConfig() {
        const values = this.editManagerForm;
        this.$refs.editManagerForm.validate((valid) => {
          if (valid) {
            let url = `${this.$store.state.islhurl}majorProjectManager/edit`
            if(this.editManagerForm.id == null) {
              url = `${this.$store.state.islhurl}majorProjectManager/add`
            }
            let pm = {
              ...values,
              islhToken: sessionStorage.getItem('islhtoken'),
              effectiveStartTime: moment(values.effectiveTime[0]).format('YYYY-MM-DD HH:mm:ss'),
              effectiveEndTime: moment(values.effectiveTime[1]).format('YYYY-MM-DD HH:mm:ss'),
            }
            delete pm.effectiveTime;
            this.confirmLoading = true;
            this._post(url,pm).then(
              res =>{
                if(res.code === 200) {
									this.$Message.success('Successful!' );
									this.getProjectManagerList();
                  this.closeModal();
								} else {
									this.$message.error(res.message || 'Failed!' );
								}
								this.confirmLoading = false;
              }
            )
          }
        });
      },
      changePage (val) {
        this.currentPage = val
        this.getProjectManagerList();
      },
      changePageSize (val) {
        this.pageSize = val
        this.getProjectManagerList();
      },
      openUpload(row) {
        this.uploadModal = true;
        this.uploadForm = { 
          id: row.id,
          file: row.certificateFileName || '',
        };
        if(row.certificateFileName) {
          this.fileList = [{
            fileName: row.certificateFileName,
            name: row.certificateFileName,
            fileAliasName: row.certificateFileAliasName,
            url: `${this.$store.state.islhurl}s3/download?fileAliasName=${encodeURIComponent(row.certificateFileAliasName)}&fileName=${encodeURIComponent(row.certificateFileName)}`
          }]
        }
      },
      closeUpload() {
        this.uploadModal = false;
        this.uploadForm = {};
        this.fileList = []
      },
      uploadConfirm() {
        this.$refs.uploadForm.validate((valid) => {
          if (valid) {
            let fd = new FormData();
						let params = {
							islhToken: sessionStorage.getItem("islhtoken"),
              id: this.uploadForm.id
						}
            fd.append('file', this.fileList[0].raw);
						fd.append('managerCertParam', new Blob([JSON.stringify(params)], {type: 'application/json'}))
						console.log('params', fd)
            let url = `${this.$store.state.islhurl}majorProjectManager/uploadCertificate`
            this.uploadLoading = true;
            this._post(url, fd).then(
              res =>{
                if(res.code === 200) {
									this.$Message.success('Successful!' );
									this.getProjectManagerList();
                  this.closeUpload();
								} else {
									this.$message.error(res.message || 'Failed!' );
								}
								this.uploadLoading = false;
              }
            )
          }
        });
      },
			beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isLt2M) {
          this.$message.error('File cannot be larger than 20MB!');
        }
        return isLt2M;
      },
      handleExceed() {
        this.$message.warning('Only one file is allowed for upload.');
      },
			handlePreview(file) {
				if(file.url) {
					window.open(file.url)
					// this._get(file.url).then(
					// 	res => { 
					// 	}
					// )
				}
			},
			changeFile(file, fileList) {
        this.fileList = [file];
				this.uploadForm = {
					...this.uploadForm,
					file: file.raw
				};
      },
			handleRemove() {
				this.fileList = [];
				this.uploadForm = {
					...this.uploadForm,
					file: []
				};
				this.fileList = []
			},
      openImport() {
        this.importModal = true;
      },
      closeImport() {
        this.importModal = false;
        this.importForm = {};
        this.importFileList = []
      },
      importConfirm() {
        this.$refs.importForm.validate((valid) => {
          if (valid) {
            let fd = new FormData();
            fd.append('file', this.importFileList[0].raw);
						fd.append('islhToken', sessionStorage.getItem("islhtoken"))
						console.log('params', fd)
            let url = `${this.$store.state.islhurl}majorProjectManager/import`
            this.importLoading = true;
            this._post(url, fd).then(
              res =>{
                if(res.code === 200) {
									this.$Message.success('Successful!' );
									this.getProjectManagerList();
                  this.closeImport();
								} else {
									this.$message.error(res.message || 'Failed!' );
								}
								this.importLoading = false;
              }
            )
          }
        });
      },
			changeImportFile(file, fileList) {
        this.importFileList = [file];
				this.importForm = {
					...this.importForm,
					file: file.raw
				};
      },
			handleImportRemove() {
				this.importFileList = [];
				this.importForm = {
					...this.importForm,
					file: []
				};
				this.importFileList = []
			},
    }
  }
</script>
<style lang="less" scoped>
.projectManagerMain {
  padding: 0 15px;
	.el-form {
		padding: 20px 0 0 0;
		.el-form-item {
			margin-bottom: 10px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
		/deep/.el-select {
			width: 100%;
		}
    /deep/.el-date-editor .el-range-input {
      font-size: 12px;
    }
	}
}
.managerDialog {
  /deep/.el-dialog__body {
    padding: 0 20px;
    .el-form-item {
      padding-bottom: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/sysdata/projectManagerMaintenance/index.vue